var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9699 53.3403C55.0978 52.7757 55.9022 52.7757 56.0301 53.3403L56.1646 53.934C56.7548 56.5396 58.8396 58.5436 61.4665 59.0305C61.9872 59.127 61.9872 59.873 61.4665 59.9695C58.8396 60.4564 56.7548 62.4604 56.1646 65.066L56.0301 65.6597C55.9022 66.2243 55.0978 66.2243 54.9699 65.6597L54.8354 65.066C54.2452 62.4604 52.1604 60.4564 49.5335 59.9695C49.0128 59.873 49.0128 59.127 49.5335 59.0305C52.1604 58.5436 54.2452 56.5396 54.8354 53.934L54.9699 53.3403Z",
    fill: "url(#paint0_linear_45185_10398)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3046 24.0313C75.3999 23.2049 76.6001 23.2049 76.6954 24.0313L77.4092 30.222C77.7654 33.3114 80.1171 35.7954 83.1824 36.32L88.968 37.31C89.7439 37.4428 89.7439 38.5572 88.968 38.69L83.1824 39.68C80.1171 40.2046 77.7654 42.6886 77.4092 45.778L76.6954 51.9687C76.6001 52.7951 75.3999 52.7951 75.3046 51.9687L74.5908 45.778C74.2346 42.6886 71.8829 40.2046 68.8176 39.68L63.032 38.69C62.2561 38.5572 62.2561 37.4428 63.032 37.31L68.8176 36.32C71.8829 35.7954 74.2346 33.3114 74.5908 30.222L75.3046 24.0313Z",
    fill: "url(#paint1_linear_45185_10398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10398",
    x1: 55.5,
    y1: 51,
    x2: 55.5,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10398",
    x1: 76,
    y1: 20.8571,
    x2: 76,
    y2: 55.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar6);
export default __webpack_public_path__ + "static/media/star-6.841eb74d79a369ac3b3cf6e1f1308d5c.svg";
export { ForwardRef as ReactComponent };